/* Quote marquee — one quote at a time, crossfading.
 *
 * Added by the art-direction pass. design-tokens.md §6 rules out auto-advancing
 * content; Olivia chose the art-direction brief's cycling quotes instead, and
 * the override is recorded there. This file carries the two obligations that
 * come with it.
 *
 *   1. WCAG 2.2.2 — Pause, Stop, Hide. Auto-updating content that starts on its
 *      own and runs for more than five seconds must be pausable. The control is
 *      revealed by this script rather than rendered visible by Liquid, so a
 *      visitor with JavaScript blocked is never shown a button that does
 *      nothing.
 *
 *   2. prefers-reduced-motion. The cycle never starts. Every quote renders
 *      stacked and static, which is also the no-JavaScript path.
 *
 * Content is never gated on this script: the quotes are all in the DOM and all
 * visible until `data-cycling` is set, so a failure here degrades to a stack
 * rather than to an empty panel. The same reason the hidden quotes are not
 * aria-hidden — a screen reader gets the whole set in reading order whatever is
 * on screen.
 */

(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

  function startCycle(root) {
    var quotes = Array.prototype.slice.call(root.querySelectorAll('[data-quote]'));
    if (quotes.length < 2) return;

    var section = root.closest('.oc-section') || root.parentNode;
    var button = section.querySelector('[data-quote-pause]');
    var label = button && button.querySelector('[data-quote-pause-label]');
    var playLabel = (button && button.getAttribute('data-play-label')) || 'Play';
    var pauseLabel = label ? label.textContent.trim() : 'Pause';

    var interval = parseInt(root.getAttribute('data-interval'), 10);
    if (!interval || interval < 2000) interval = 6000;

    var index = 0;
    var timer = null;
    var paused = false;

    root.setAttribute('data-cycling', 'true');

    function show(next) {
      quotes[index].classList.remove('is-current');
      index = next;
      quotes[index].classList.add('is-current');
    }

    function tick() {
      show((index + 1) % quotes.length);
    }

    function play() {
      if (timer) return;
      timer = window.setInterval(tick, interval);
    }

    function stop() {
      window.clearInterval(timer);
      timer = null;
    }

    if (button) {
      button.hidden = false;
      button.addEventListener('click', function () {
        paused = !paused;
        button.setAttribute('aria-pressed', paused ? 'true' : 'false');
        if (label) label.textContent = paused ? playLabel : pauseLabel;
        if (paused) stop();
        else play();
      });
    }

    /* A tab in the background is not being read. Cycling on regardless burns
       battery and means returning to the tab lands mid-transition. */
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop();
      else if (!paused) play();
    });

    /* Someone reading a quote with the pointer resting on it is reading it.
       Not a WCAG requirement — the pause control covers that — but it stops the
       panel changing under a reader who has stopped to take one in. */
    root.addEventListener('mouseenter', function () {
      if (!paused) stop();
    });
    root.addEventListener('mouseleave', function () {
      if (!paused) play();
    });

    play();
  }

  function init() {
    if (reduced.matches) return;
    var roots = document.querySelectorAll('[data-quote-cycle]');
    for (var i = 0; i < roots.length; i++) startCycle(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
